export default {
      id: "avoidable_operating_costs-usage",
      viewBox: "0 0 45 46.5",
      url: __webpack_public_path__ + "img/icons.svg#avoidable_operating_costs",
      toString: function () {
        return this.url;
      }
    }